import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { LugarProduccionService } from './lugarproduccion.service';
import {
    SolicitudAtestFitoLugarProduccionViewModel,
    TwParcelasAtestFitoViewModel,
    TwViveroAtestFitoViewModel,
    TwAlmacenConfeccionAtestFitoViewModel,
    TwOtroLugarProduccionAtestFitoViewModel,
    RecintoInfoRequestViewModel,
    ParcelaSimplifVerificadaSigpacViewModel,
} from './lugarproduccion.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { MunicipioViewModel } from '../../../_mantenimiento/general/municipios/municipios.types';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-lugarProduccion-edit',
    templateUrl: './lugarProduccion.component.html',
})
/** solicitud-edit component*/
export class LugarProduccionComponent extends ComponentBase implements OnInit {
    /** solicitud-edit ctor */

    editMode = false;
    editTitle = 'Nueva';

    solicitudAtestFitoLugarProduccion: SolicitudAtestFitoLugarProduccionViewModel;
    resultValidacionParcelaSigpac: ParcelaSimplifVerificadaSigpacViewModel;
    tituloEstadoSolicitud: string;
    habilitarGuardar = true;
    habilitarEdicion = true;
    visibilitySpinner = false;
    IdTipoSolicitudAtestFito: number;
    tituloTipoSolicitud: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitudAtestFito: number;
    refAtestFito: string;
    urlVisor: string;

    colsParcelas: any[];
    numeroParcelas = 0;

    idProvinciaParcela = null;
    municipioSigPac = null;
    agregado = null;
    zona = null;
    poligono = null;
    parcela = null;
    recinto = null;

    listProvinciaParcela: Tc[];
    //listProvinciaParcela$: Observable<Tc[]>;
    listMunicipioParcela: MunicipioViewModel[];
    //listMunicipioParcela$: Observable<Tc[]>;
    listProvinciaVivero: Tc[];
    listMunicipioVivero: Tc[];
    listProvinciaAlmacen: Tc[];
    listMunicipioAlmacen: Tc[];
    listProvinciaOtroLugar: Tc[];
    listMunicipioOtroLugar: Tc[];

    public isCollapsedParcelas = false;
    public isCollapsedVivero = false;
    public isCollapsedAlmacen = false;
    public isCollapsedOtroLugar = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private configurationService: ConfigurationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private navMenuService: NavMenuService,
        private lugarProduccionService: LugarProduccionService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudAtestFitoLugarProduccion = new SolicitudAtestFitoLugarProduccionViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.configurationService.getUrlVisorSIGPAC().subscribe(s => (this.urlVisor = s));

        this.guardRefreshPage(id);

        this.createForm();

        //Siempre tendrá un id.
        if (id) {
            this.loading = true;

            //recuperar la solicitud
            this.lugarProduccionService.getSolicitudAtestFitoLugarProduccion(id).subscribe(result => {
                this.solicitudAtestFitoLugarProduccion = result;

                //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
                //valor de ciertas columnas al seleccionar un elemento
                this.globalService.getProvinciasByComunidad(this.solicitudAtestFitoLugarProduccion.IdComunidadAutonoma).subscribe(res => {
                    this.listProvinciaParcela = res;
                });

                this.globalService.getProvinciasByComunidad(this.solicitudAtestFitoLugarProduccion.IdComunidadAutonoma).subscribe(res => {
                    this.listProvinciaVivero = res;
                    this.listProvinciaAlmacen = res;
                    this.listProvinciaOtroLugar = res;
                });

                this.IdTipoSolicitudAtestFito = this.solicitudAtestFitoLugarProduccion.IdTipoSolicitud;
                this.tituloTipoSolicitud = this.solicitudAtestFitoLugarProduccion.IdTipoSolicitudDescripcion;
                this.tituloEstadoSolicitud = this.solicitudAtestFitoLugarProduccion.IdEstadoDescripcion;
                this.codigoTipoSolicitud = this.solicitudAtestFitoLugarProduccion.CodigoTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.solicitudAtestFitoLugarProduccion.IdEstado;
                this.refAtestFito = this.solicitudAtestFitoLugarProduccion.RefAtestFito;

                this.updateForm();

                this.numeroParcelas = this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.length;

                this.loading = false;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_ATESTACION,
                    this.solicitudAtestFitoLugarProduccion.IdEstado,
                ).Visible;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_LUGAR_PRODUCCION_ATESTACION,
                    this.solicitudAtestFitoLugarProduccion.IdEstado,
                ).Editable;

                if (!this.habilitarEdicion) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }
            });
        }

        this.colsParcelas = [
            { field: 'Link', header: '' },
            { field: 'CodigoSigPac', header: 'Código SigPac' },
            { field: 'SuperficieSigPac', header: 'Superficie SigPac (ha)' },
            { field: 'UsoSigPac', header: 'Uso SigPac' },
            { field: 'ProvinciaParcelaDescripcion', header: 'Provincia' },
            { field: 'MunicipioParcelaDescripcion', header: 'Municipio' },
            { field: 'DireccionParcela', header: 'Dirección' },
        ];
    }

    createForm() {
        this.form = this.fb.group({
            CodigoSigPac: '',
            MunicipioSigpac: '',
            Agregado: '',
            Zona: '',
            Poligono: '',
            Parcela: '',
            Recinto: '',

            SuperficieSigPac: null,
            UsoSigPac: '',
            IdProvinciaParcela: null,
            ProvinciaParcelaDescripcion: '',
            IdMunicipioParcela: null,
            MunicipioParcelaDescripcion: '',
            DireccionParcela: '',

            RazonSocialVivero: '',
            DireccionVivero: '',
            IdProvinciaVivero: null,
            IdMunicipioVivero: null,
            CodigoPostalVivero: '',

            NumRgseaa: '',
            RazonSocialAlmacen: '',
            DireccionAlmacen: '',
            IdProvinciaAlmacen: null,
            IdMunicipioAlmacen: null,
            CodigoPostalAlmacen: '',

            RazonSocialOtroLugar: '',
            DireccionOtroLugar: '',
            IdProvinciaOtroLugar: null,
            IdMunicipioOtroLugar: null,
            CodigoPostalOtroLugar: '',
        });
    }

    updateForm() {
        this.form.setValue({
            CodigoSigPac: '',
            MunicipioSigpac: '',
            Agregado: '',
            Zona: '',
            Poligono: '',
            Parcela: '',
            Recinto: '',

            SuperficieSigPac: null,
            UsoSigPac: '',
            IdProvinciaParcela: null,
            ProvinciaParcelaDescripcion: '',
            IdMunicipioParcela: null,
            MunicipioParcelaDescripcion: '',
            DireccionParcela: '',

            RazonSocialVivero:
                this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito.RazonSocialVivero
                    : null,
            DireccionVivero:
                this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito.DireccionVivero
                    : null,
            IdProvinciaVivero:
                this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito.IdProvinciaVivero
                    : null,
            IdMunicipioVivero:
                this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito.IdMunicipioVivero
                    : null,
            CodigoPostalVivero:
                this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwViveroAtestFito.CodigoPostalVivero
                    : null,

            NumRgseaa:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.NumRgseaa
                    : null,
            RazonSocialAlmacen:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.RazonSocialAlmacen
                    : null,
            DireccionAlmacen:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.DireccionAlmacen
                    : null,
            IdProvinciaAlmacen:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.IdProvinciaAlmacen
                    : null,
            IdMunicipioAlmacen:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.IdMunicipioAlmacen
                    : null,
            CodigoPostalAlmacen:
                this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.CodigoPostalAlmacen
                    : null,

            RazonSocialOtroLugar:
                this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.RazonSocialOtroLugar
                    : null,
            DireccionOtroLugar:
                this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.DireccionOtroLugar
                    : null,
            IdProvinciaOtroLugar:
                this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.IdProvinciaOtroLugar
                    : null,
            IdMunicipioOtroLugar:
                this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.IdMunicipioOtroLugar
                    : null,
            CodigoPostalOtroLugar:
                this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito != null
                    ? this.solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.CodigoPostalOtroLugar
                    : null,
        });

        //const idProvinciaParcela = this.form.value.IdProvinciaParcela;
        //this.listMunicipioParcela$ = this.globalService.getMunicipios(idProvinciaParcela);

        const idProvinciaVivero = this.form.value.IdProvinciaVivero;
        this.globalService.getMunicipios(idProvinciaVivero).subscribe(res => {
            this.listMunicipioVivero = res;
        });

        const idProvinciaAlmacen = this.form.value.IdProvinciaAlmacen;
        this.globalService.getMunicipios(idProvinciaAlmacen).subscribe(res => {
            this.listMunicipioAlmacen = res;
        });

        const idProvinciaOtroLugar = this.form.value.IdProvinciaOtroLugar;
        this.globalService.getMunicipios(idProvinciaOtroLugar).subscribe(res => {
            this.listMunicipioOtroLugar = res;
        });
    }

    private DisableControlsConsulta() {
        //this.form.controls['CodigoSigPac'].disable();
        this.form.controls['MunicipioSigpac'].disable();
        this.form.controls['Agregado'].disable();
        this.form.controls['Zona'].disable();
        this.form.controls['Poligono'].disable();
        this.form.controls['Parcela'].disable();
        this.form.controls['Recinto'].disable();

        this.form.controls['SuperficieSigPac'].disable();
        this.form.controls['UsoSigPac'].disable();
        this.form.controls['IdProvinciaParcela'].disable();
        this.form.controls['IdMunicipioParcela'].disable();
        this.form.controls['DireccionParcela'].disable();

        this.form.controls['RazonSocialVivero'].disable();
        this.form.controls['DireccionVivero'].disable();
        this.form.controls['IdProvinciaVivero'].disable();
        this.form.controls['IdMunicipioVivero'].disable();
        this.form.controls['CodigoPostalVivero'].disable();

        this.form.controls['NumRgseaa'].disable();
        this.form.controls['RazonSocialAlmacen'].disable();
        this.form.controls['DireccionAlmacen'].disable();
        this.form.controls['IdProvinciaAlmacen'].disable();
        this.form.controls['IdMunicipioAlmacen'].disable();
        this.form.controls['CodigoPostalAlmacen'].disable();

        this.form.controls['RazonSocialOtroLugar'].disable();
        this.form.controls['DireccionOtroLugar'].disable();
        this.form.controls['IdProvinciaOtroLugar'].disable();
        this.form.controls['IdMunicipioOtroLugar'].disable();
        this.form.controls['CodigoPostalOtroLugar'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    onShowSigpac() {
        const codigoSigpac: string = this.mapearUrlVisorSigpac();

        const url = this.urlVisor + '?' + codigoSigpac;

        if (codigoSigpac != '') {
            if (confirm('Este enlace lo llevará a un sitio web externo, ¿desea continuar?')) {
                window.open(
                    url,
                    'Visor SIGPAC',
                    'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=600,top=' +
                        (screen.height - 400) +
                        ',left=' +
                        (screen.width - 840),
                );
            }
        }
    }

    onValidarSigpac() {
        this.removeValidationsParcela();

        this.addValidator('IdProvinciaParcela', Validators.required);
        this.addValidator('IdMunicipioParcela', Validators.required);
        this.addValidator('MunicipioSigpac', Validators.required);
        this.addValidator('Agregado', Validators.required);
        this.addValidator('Zona', Validators.required);
        this.addValidator('Poligono', Validators.required);
        this.addValidator('Parcela', Validators.required);
        this.addValidator('Recinto', Validators.required);

        if (!this.form.valid) {
            return;
        }

        //Me aseguro de que los campos SigPac esten habilitados
        this.enableCamposSigPac();
        let model: RecintoInfoRequestViewModel = new RecintoInfoRequestViewModel();

        model.Provincia = this.form.value.IdProvinciaParcela.toString();
        model.Municipio = this.form.value.MunicipioSigpac.toString();
        model.Agregado = this.form.value.Agregado.toString();
        model.Zona = this.form.value.Zona.toString();
        model.Poligono = this.form.value.Poligono.toString();
        model.Parcela = this.form.value.Parcela.toString();
        model.Recinto = this.form.value.Recinto.toString();

        this.lugarProduccionService.validarParcelaSigpac(model).subscribe(result => {
            if (result) {
                this.resultValidacionParcelaSigpac = result;

                this.form.patchValue({
                    SuperficieSigPac: this.resultValidacionParcelaSigpac.Superficie / 10000,
                    UsoSigPac: this.resultValidacionParcelaSigpac.Uso_sigpac,
                });
                this.idProvinciaParcela = this.form.value.IdProvinciaParcela.toString();
                this.municipioSigPac = this.form.value.MunicipioSigpac.toString();
                this.agregado = this.form.value.Agregado.toString();
                this.zona = this.form.value.Zona.toString();
                this.poligono = this.form.value.Poligono.toString();
                this.parcela = this.form.value.Parcela.toString();
                this.recinto = this.form.value.Recinto.toString();
                //Deshabilitar los campos SigPac para que no se puedan añadir sin validar
                this.disableCamposSigPac();
            } else {
                this.addErrorMessage('No se han obtenido resultados de esta parcela');
            }
        });
    }

    mapearUrlVisorSigpac(): string {
        let url = '';

        if (
            this.form.value.IdProvinciaParcela != null &&
            this.form.value.MunicipioSigpac != null &&
            this.form.value.Agregado != null &&
            this.form.value.Zona != null &&
            this.form.value.Poligono != null &&
            this.form.value.Parcela != null
        ) {
            if (this.form.value.Recinto != null) {
                url =
                    'provincia=' +
                    this.form.value.IdProvinciaParcela.toString() +
                    '&' +
                    'municipio=' +
                    this.form.value.MunicipioSigpac.toString() +
                    '&' +
                    'agregado=' +
                    this.form.value.Agregado.toString() +
                    '&' +
                    'zona=' +
                    this.form.value.Zona.toString() +
                    '&' +
                    'poligono=' +
                    this.form.value.Poligono.toString() +
                    '&' +
                    'parcela=' +
                    this.form.value.Parcela.toString() +
                    '&' +
                    'recinto=' +
                    this.form.value.Recinto.toString();
            } else {
                url =
                    'provincia=' +
                    this.form.value.IdProvinciaParcela.toString() +
                    '&' +
                    'municipio=' +
                    this.form.value.MunicipioSigpac.toString() +
                    '&' +
                    'agregado=' +
                    this.form.value.Agregado.toString() +
                    '&' +
                    'zona=' +
                    this.form.value.Zona.toString() +
                    '&' +
                    'poligono=' +
                    this.form.value.Poligono.toString() +
                    '&' +
                    'parcela=' +
                    this.form.value.Parcela.toString();
            }
            //si ya he validado los campos en SigPac y los controles están deshabilitados
        } else if (
            this.idProvinciaParcela != null &&
            this.municipioSigPac != null &&
            this.agregado != null &&
            this.zona != null &&
            this.poligono != null &&
            this.parcela != null
        ) {
            if (this.recinto != null) {
                url =
                    'provincia=' +
                    this.idProvinciaParcela +
                    '&' +
                    'municipio=' +
                    this.municipioSigPac +
                    '&' +
                    'agregado=' +
                    this.agregado +
                    '&' +
                    'zona=' +
                    this.zona +
                    '&' +
                    'poligono=' +
                    this.poligono +
                    '&' +
                    'parcela=' +
                    this.parcela +
                    '&' +
                    'recinto=' +
                    this.recinto;
            } else {
                url =
                    'provincia=' +
                    this.idProvinciaParcela +
                    '&' +
                    'municipio=' +
                    this.municipioSigPac +
                    '&' +
                    'agregado=' +
                    this.agregado +
                    '&' +
                    'zona=' +
                    this.zona +
                    '&' +
                    'poligono=' +
                    this.poligono +
                    '&' +
                    'parcela=' +
                    this.parcela;
            }
        }

        return url;
    }

    enableCamposSigPac() {
        this.form.controls['Agregado'].enable();
        this.form.controls['Zona'].enable();
        this.form.controls['Poligono'].enable();
        this.form.controls['Parcela'].enable();
        this.form.controls['Recinto'].enable();
        this.form.controls['IdProvinciaParcela'].enable();
        this.form.controls['IdMunicipioParcela'].enable();
    }

    disableCamposSigPac() {
        this.form.controls['Agregado'].disable();
        this.form.controls['Zona'].disable();
        this.form.controls['Poligono'].disable();
        this.form.controls['Parcela'].disable();
        this.form.controls['Recinto'].disable();
        this.form.controls['IdProvinciaParcela'].disable();
        this.form.controls['IdMunicipioParcela'].disable();
    }

    mapearCodigoSigpac(): string {
        let codigo = '';

        codigo =
            this.form.value.IdProvinciaParcela.toString() +
            ':' +
            this.form.value.MunicipioSigpac.toString() +
            ':' +
            this.form.value.Agregado.toString() +
            ':' +
            this.form.value.Zona.toString() +
            ':' +
            this.form.value.Poligono.toString() +
            ':' +
            this.form.value.Parcela.toString() +
            ':' +
            this.form.value.Recinto.toString();

        return codigo;
    }

    removeValidationsParcela() {
        this.removeValidators('IdProvinciaParcela');
        this.removeValidators('IdMunicipioParcela');
        this.removeValidators('MunicipioSigpac');
        this.removeValidators('Agregado');
        this.removeValidators('Zona');
        this.removeValidators('Poligono');
        this.removeValidators('Parcela');
        this.removeValidators('Recinto');
        this.removeValidators('SuperficieSigPac');
        this.removeValidators('UsoSigPac');
    }

    onAddParcela() {
        this.removeValidationsParcela();

        this.addValidator('IdProvinciaParcela', Validators.required);
        this.addValidator('IdMunicipioParcela', Validators.required);
        this.addValidator('MunicipioSigpac', Validators.required);
        this.addValidator('Agregado', Validators.required);
        this.addValidator('Zona', Validators.required);
        this.addValidator('Poligono', Validators.required);
        this.addValidator('Parcela', Validators.required);
        this.addValidator('Recinto', Validators.required);
        this.addValidator('SuperficieSigPac', Validators.required);
        this.addValidator('UsoSigPac', Validators.required);

        if (!this.form.valid) {
            return;
        }

        if (this.form.value.MunicipioParcelaDescripcion != '') {
            //Habilitar campos Sigpac para hacer los mapeos
            this.enableCamposSigPac();

            let parcela = new TwParcelasAtestFitoViewModel();

            parcela.CodigoSigPac = this.mapearCodigoSigpac();
            parcela.SuperficieSigPac = this.form.value.SuperficieSigPac;
            parcela.UsoSigPac = this.form.value.UsoSigPac;
            parcela.IdProvinciaParcela = this.form.value.IdProvinciaParcela;
            parcela.ProvinciaParcelaDescripcion = this.form.value.ProvinciaParcelaDescripcion;
            parcela.IdMunicipioParcela = this.form.value.IdMunicipioParcela;
            parcela.MunicipioParcelaDescripcion = this.form.value.MunicipioParcelaDescripcion;
            parcela.DireccionParcela = this.form.value.DireccionParcela;

            //Convierto las comas en puntos
            parcela.SuperficieSigPac = Number(parcela.SuperficieSigPac?.toString().replace(',', '.'));

            //comprobar si ya existe el elemento en la colleccion
            const found = this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.some(item => item.CodigoSigPac == parcela.CodigoSigPac);
            if (!found) {
                //RDLF-->cambia la forma de introducir elementos al array para que refresque la p-tabla
                this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection = [
                    ...this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection,
                    parcela,
                ];
                this.numeroParcelas = this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.length;
                this.onResetParcela();
            } else {
                this.addErrorMessage('No se pueden añadir parcelas duplicadas');
                this.disableCamposSigPac();
            }
        }

        this.removeValidationsParcela();
    }

    onDeleteParcela(parcela: TwParcelasAtestFitoViewModel) {
        //this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.splice(this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.indexOf(parcela), 1);
        //RDLF-->cambia la forma de eliminar elementos al array para que refresque la p-tabla
        this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection = [
            ...this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.slice(
                0,
                this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.indexOf(parcela),
            ),
            ...this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.slice(
                this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.indexOf(parcela) + 1,
            ),
        ];

        this.numeroParcelas = this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection.length;
    }

    onResetParcela() {
        this.form.patchValue({
            //CodigoSigPac: '',
            MunicipioSigpac: '',
            Agregado: '',
            Zona: '',
            Poligono: '',
            Parcela: '',
            Recinto: '',

            SuperficieSigPac: null,
            UsoSigPac: '',
            IdProvinciaParcela: null,
            ProvinciaParcelaDescripcion: '',
            IdMunicipioParcela: null,
            MunicipioParcelaDescripcion: '',
            DireccionParcela: '',
        });
        this.idProvinciaParcela = null;
        this.municipioSigPac = null;
        this.agregado = null;
        this.zona = null;
        this.poligono = null;
        this.parcela = null;
        this.recinto = null;

        this.listMunicipioParcela = [];
        this.removeValidationsParcela();
        this.enableCamposSigPac();
    }

    onSelectProvinciaParcela() {
        const idProvincia = this.form.controls['IdProvinciaParcela'].value; //this.form.value.IdProvinciaParcela;

        let seleccionado = this.listProvinciaParcela.find(x => x.Id == idProvincia);
        if (seleccionado != null) {
            this.form.patchValue({
                ProvinciaParcelaDescripcion: (<Tc>seleccionado).Descripcion,
            });
        }

        //this.listMunicipioParcela$ = this.globalService.getMunicipios(idProvincia);

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.globalService.getMunicipiosComplete(idProvincia).subscribe(res => {
            this.listMunicipioParcela = res;
        });

        this.form.patchValue({
            IdMunicipioParcela: null,
            MunicipioParcelaDescripcion: '',
        });
    }

    onSelectMunicipioParcela() {
        const idMunicipio = this.form.controls['IdMunicipioParcela'].value;

        let seleccionado = this.listMunicipioParcela.find(x => x.Id == idMunicipio);
        if (seleccionado != null) {
            this.form.patchValue({
                MunicipioParcelaDescripcion: (<MunicipioViewModel>seleccionado).Descripcion,
                MunicipioSigpac: (<MunicipioViewModel>seleccionado).MunicipioSigpac,
            });
        }
    }

    onSelectProvinciaVivero() {
        const idProvincia = this.form.value.IdProvinciaVivero;

        this.globalService.getMunicipios(idProvincia).subscribe(res => {
            this.listMunicipioVivero = res;
        });

        this.form.patchValue({
            IdMunicipioVivero: null,
        });
    }

    onSelectProvinciaAlmacen() {
        const idProvincia = this.form.value.IdProvinciaAlmacen;

        this.globalService.getMunicipios(idProvincia).subscribe(res => {
            this.listMunicipioAlmacen = res;
        });

        this.form.patchValue({
            IdMunicipioAlmacen: null,
        });
    }

    onSelectProvinciaOtroLugar() {
        const idProvincia = this.form.value.IdProvinciaOtroLugar;

        this.globalService.getMunicipios(idProvincia).subscribe(res => {
            this.listMunicipioOtroLugar = res;
        });

        this.form.patchValue({
            IdMunicipioOtroLugar: null,
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/atestacion/datosbasicos', this.solicitudAtestFitoLugarProduccion.Id]);
    }

    guardarLugarProduccion() {
        this.onSubmit();
    }

    tieneVivero() {
        let respuesta = false;
        if (
            (this.form.value.RazonSocialVivero != '' && this.form.value.RazonSocialVivero != null) ||
            (this.form.value.DireccionVivero != '' && this.form.value.DireccionVivero != null) ||
            this.form.value.IdProvinciaVivero != null ||
            this.form.value.IdMunicipioVivero != null ||
            (this.form.value.CodigoPostalVivero != '' && this.form.value.CodigoPostalVivero != null)
        ) {
            respuesta = true;
        }
        return respuesta;
    }

    tieneAlmacen() {
        let respuesta = false;
        if (
            (this.form.value.NumRgseaa != '' && this.form.value.NumRgseaa != null) ||
            (this.form.value.RazonSocialAlmacen != '' && this.form.value.RazonSocialAlmacen != null) ||
            (this.form.value.DireccionAlmacen != '' && this.form.value.DireccionAlmacen != null) ||
            this.form.value.IdProvinciaAlmacen != null ||
            this.form.value.IdMunicipioAlmacen != null ||
            (this.form.value.CodigoPostalAlmacen != '' && this.form.value.CodigoPostalAlmacen != null)
        ) {
            respuesta = true;
        }
        return respuesta;
    }

    tieneOtroLugar() {
        let respuesta = false;
        if (
            (this.form.value.RazonSocialOtroLugar != '' && this.form.value.RazonSocialOtroLugar != null) ||
            (this.form.value.DireccionOtroLugar != '' && this.form.value.DireccionOtroLugar != null) ||
            this.form.value.IdProvinciaOtroLugar != null ||
            this.form.value.IdMunicipioOtroLugar != null ||
            (this.form.value.CodigoPostalOtroLugar != '' && this.form.value.CodigoPostalOtroLugar != null)
        ) {
            respuesta = true;
        }
        return respuesta;
    }

    onSubmit() {
        this.removeValidationsParcela();

        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let solicitudAtestFitoLugarProduccion = new SolicitudAtestFitoLugarProduccionViewModel();

        solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection = this.solicitudAtestFitoLugarProduccion.TwParcelasAtestFitoCollection;
        //VIVERO
        if (this.tieneVivero()) {
            solicitudAtestFitoLugarProduccion.TwViveroAtestFito = new TwViveroAtestFitoViewModel();

            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.RazonSocialVivero = this.form.value.RazonSocialVivero;
            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.DireccionVivero = this.form.value.DireccionVivero;
            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.IdProvinciaVivero = this.form.value.IdProvinciaVivero;
            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.IdMunicipioVivero = this.form.value.IdMunicipioVivero;
            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.CodigoPostalVivero = this.form.value.CodigoPostalVivero;

            solicitudAtestFitoLugarProduccion.TwViveroAtestFito.IdSolicitudAtestFito = this.solicitudAtestFitoLugarProduccion.Id;
        }

        //ALMACEN
        if (this.tieneAlmacen()) {
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito = new TwAlmacenConfeccionAtestFitoViewModel();

            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.NumRgseaa = this.form.value.NumRgseaa;
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.RazonSocialAlmacen = this.form.value.RazonSocialAlmacen;
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.DireccionAlmacen = this.form.value.DireccionAlmacen;
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.IdProvinciaAlmacen = this.form.value.IdProvinciaAlmacen;
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.IdMunicipioAlmacen = this.form.value.IdMunicipioAlmacen;
            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.CodigoPostalAlmacen = this.form.value.CodigoPostalAlmacen;

            solicitudAtestFitoLugarProduccion.TwAlmacenConfeccionAtestFito.IdSolicitudAtestFito = this.solicitudAtestFitoLugarProduccion.Id;
        }

        //OTRO LUGAR
        if (this.tieneOtroLugar()) {
            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito = new TwOtroLugarProduccionAtestFitoViewModel();

            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.RazonSocialOtroLugar = this.form.value.RazonSocialOtroLugar;
            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.DireccionOtroLugar = this.form.value.DireccionOtroLugar;
            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.IdProvinciaOtroLugar = this.form.value.IdProvinciaOtroLugar;
            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.IdMunicipioOtroLugar = this.form.value.IdMunicipioOtroLugar;
            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.CodigoPostalOtroLugar = this.form.value.CodigoPostalOtroLugar;

            solicitudAtestFitoLugarProduccion.TwOtroLugarProduccionAtestFito.IdSolicitudAtestFito = this.solicitudAtestFitoLugarProduccion.Id;
        }

        solicitudAtestFitoLugarProduccion.Id = this.solicitudAtestFitoLugarProduccion.Id;

        this.lugarProduccionService.editSolicitudAtestFitoLugarProduccion(solicitudAtestFitoLugarProduccion).subscribe({
            next: res => {
                this.addSuccessMessage('Lugares de Producción guardados correctamente');
                //this.onBack();
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
